import React from 'react'

type ContextProps = {
  [key: string]: string
}

const ExperimentContext = React.createContext<Partial<ContextProps>>({})
ExperimentContext.displayName = 'ExperimentContext'

export default ExperimentContext
